/**
 * Font family style object for consistent typography.
 *
 * @type {Object}
 * @property {string} fontFamily - The font family CSS string.
 */
export const fontFamilyStyle = {
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
};